export default __webpack_public_path__ + "static/media/sound.0422283a.png";